import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import Header from "./components/Header";
// import Footer from "./components/Footer";
import { Components } from '../utils/npm'
import Loader from '../components/Loader'

import { lazy, useEffect, useLayoutEffect, useRef, useState } from "react";
import { setFooterLoad, setSearchIPO } from "../store/slice/masterSlice";
import { Footer, Header } from "./MyRoutes";
import { Helmet } from "react-helmet";
import useDebounce from "../hooks/useDebounce";
import OpenAppRedirect from "../pages/HomePage/OpenAppRedirect";

export const DashboardLayout = ({ children }) => {

  const fooerLoad = useSelector((state) => state.masterSlice.isloading);
  let scrolltoTopRef = useRef();
  const location = useLocation();
  const dispatch = useDispatch();

  document.addEventListener('contextmenu', (e) => {
    e.preventDefault(); // Disable right-click
  });

  document.addEventListener('keydown', function (e) {
    // Disable F12, Ctrl+Shift+I, and Ctrl+U
    if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I') || (e.ctrlKey && e.key === 'U')) {
      e.preventDefault();
    }
  });

  // function generateSitemap() {
  //   const sitemap = new Sitemap(route)
  //     .build('https://yourwebsite.com') // Your website's base URL
  //     .save(path.resolve(__dirname, 'public/sitemap.xml')); // Location to save the sitemap file
  // }

  const scrollView = () => {
    if (scrolltoTopRef.current) {
      scrolltoTopRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    scrollView()
    dispatch(setSearchIPO(''))
  }, [location?.pathname]);

  useEffect(() => {
    const images = document.querySelectorAll("img");
    let loadedImages = 0;

    images.forEach((img) => {
      if (img.complete) {
        loadedImages++;
      } else {
        img.onload = () => {
          loadedImages++;
          if (loadedImages === images.length) {
            // setLoading(false);
          }
        };
      }
    });

    if (loadedImages === images.length) {
      // setLoading(false);
    }
  }, []);

  const canonicalUrl = `https://ipo-trend.com${location.pathname}`;

  // const worker = new Worker('worker.js');
  // worker.postMessage(data);
  // worker.onmessage = (e) => setResult(e.data);

  // useEffect(() => {
  //   const handleResize = useDebounce(() => {
  //     // resize logic
  //   }, 200);
  //   window.addEventListener('resize', handleResize);
  //   return () => window.removeEventListener('resize', handleResize);
  // }, []);


  // ---------------------------------------
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [oldPath, setOldPaths] = useState("");

  const path = window.location.pathname;

  console.log('location', window.location.href);
  console.log('app.js location', location);
  console.log('app.js path', path);

  useEffect(() => {
    if (path.includes("openapp")) {
      setOldPaths(path)
      setShouldRedirect(true); // Trigger redirection state change
    }
  }, [path]); // Dependency on path to re-run when it changes

  if (shouldRedirect) {
    // oldPath?.replace('/openapp', '')
    return <OpenAppRedirect paths={oldPath}/>;
  }

  return (
    <>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      <div ref={scrolltoTopRef}>

        {/* <header> */}
        <Header />
        {/* </header> */}
        {children}
        <Outlet />
        {/* <Footer /> */}
      </div>
    </>
  );
};

export const WithoutHeader = ({ children }) => {
  const fooerLoad = useSelector((state) => state.masterSlice.isloading);

  const [reloadLoading, setReloadLoading] = useState(true);

  useEffect(() => {
    setReloadLoading(false)
  }, [])


  const layoutRef = useRef(null);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  let scrolltoTopRef = useRef();
  const scrollView = () => {
    if (scrolltoTopRef.current) {
      scrolltoTopRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    scrollView()
  }, [children]);
  useEffect(() => {
    setReloadLoading(false)
  }, [])

  return (
    <>
      <div ref={scrolltoTopRef}>
        {/* <header> */}
        {/* <Header /> */}
        {/* </header> */}
        {children}
        <Outlet />
        {/* <Footer />  */}
      </div>
    </>
  );
};

